<template>
	<glass-card class="py-5">
		<div class="container">
			<button class="btn btn-outline-primary mb-4" @click="goBack">
				<i class="bi bi-arrow-left"></i> Back
			</button>
			<Pricing />
		</div>
	</glass-card>
</template>

<script setup>
	import { onMounted } from "vue"
	import { useRouter } from "vue-router"
	import Pricing from "@/components/Pricing.vue"
	import GlassCard from "@/components/GlassCard.vue"

	const router = useRouter()
	const goBack = () => router.back()

	onMounted(() => {
		window.scrollTo({ top: 0, left: 0, behavior: "auto" })
	})
</script>
